/* Shared add-on section module.
 *
 * Targets the unified markup emitted by snippets/addon-section.liquid:
 *   .lvly-addon-section[data-mode][data-personalisation-tag]
 *     .lvly-addon-track > .splide
 *     .lvly-addon-tile.lvly-addon-tile--{jar|addon|goodie}
 *
 * Discriminates jar vs addon by CSS class on the tile (not data-product-type).
 *
 * Loaded with `defer` AFTER global jQuery. Not an ES module - jQuery handlers
 * are registered as side effects on document ready, exactly like the legacy
 * jar-selection.js / product-v3.js handlers it replaces.
 */
(function () {
  if (typeof jQuery === 'undefined') return;

  jQuery(function ($) {
    var TILE          = '.lvly-addon-tile';
    var JAR_TILE      = '.lvly-addon-tile--jar';
    var ADDON_TILE    = '.lvly-addon-tile--addon';
    var SECTION       = '.lvly-addon-section';
    var SEE_MORE_BTN  = '.js-addon-seemore';
    var SHOW_MORE_BTN = '.lvly-addon-show-more';

    // Expander cap: 1 row by default - "Show all" reveals the full wrapped grid.
    // Desktop 8 cols, mobile 3 cols (matches CSS grid).
    var ADDON_COLS_DESKTOP = 8;
    var ADDON_COLS_MOBILE  = 3;
    var ADDON_MAX_ROWS     = 1;
    var MOBILE_BREAKPOINT  = 798;

    // ---- 1. Single-select handler for jar tiles ----------------------------
    // Click anywhere on a jar tile (or its +Add overlay) selects it; sibling
    // jars in the same section lose .active. Tag-based personalisation reveal.
    $(document).on('click', SECTION + ' ' + JAR_TILE, function (e) {
      var $tile    = $(this);
      var $section = $tile.closest(SECTION);

      // Don't intercept clicks on interactive children that have their own handlers.
      var $target = $(e.target);
      if ($target.closest(SEE_MORE_BTN + ', .addon-qty-container').length) return;

      $section.find(JAR_TILE).removeClass('active');
      $tile.addClass('active');

      togglePersonalisation($section, $tile);

      if (typeof window.updateTotalPrice === 'function') window.updateTotalPrice();
    });

    function togglePersonalisation($section, $tile) {
      var tag      = ($section.attr('data-personalisation-tag') || 'product:personalised');
      var dataTag  = ($tile.attr('data-tag') || '');
      var $input   = $section.find('.personalized-input-container');
      if (!$input.length) return;
      if (dataTag.indexOf(tag) !== -1) {
        $input.slideDown();
        $input.find('input').trigger('focus');
      } else {
        $input.slideUp();
        $input.find('input').val('');
      }
    }

    // ---- 2. Multi-toggle handler for addon tiles ---------------------------
    $(document).on('click', SECTION + ' ' + ADDON_TILE, function (e) {
      var $tile = $(this);

      var $target = $(e.target);
      if ($target.closest(SEE_MORE_BTN + ', .addon-qty-container').length) return;

      $tile.toggleClass('active');

      if (typeof window.updateTotalPrice === 'function') window.updateTotalPrice();
    });

    // Qty stepper handlers removed - the .addon-qty-container is hidden in CSS
    // for the unified tile (one-tap = qty 1). The input stays in the DOM with
    // value="1" so updateTotalPrice() and product-v3.js's cart-add still read
    // a sane number.

    // ---- 3. Filter pills (carousel-aware, Splide) --------------------------
    function applyFilter($section, tag) {
      var $tiles = $section.find(ADDON_TILE);
      $tiles.removeClass('is-filtered-out');
      if (tag && tag !== 'all') {
        var needle = ('tag:' + tag).toLowerCase();
        $tiles.each(function () {
          var d = ($(this).attr('data-tag') || '').toLowerCase();
          if (d.indexOf(needle) === -1) $(this).addClass('is-filtered-out');
        });
      }
      applyAddonRowCap($section);
    }

    function resetExpanded($section) {
      $section.find(SHOW_MORE_BTN).attr('data-expanded', 'false');
    }

    $(document).on('click', SECTION + ' .add_on_tags li', function () {
      var $li      = $(this);
      var $section = $li.closest(SECTION);
      var tag      = ($li.data('tag') || '').toString();

      if ($li.hasClass('is-empty')) return;

      // Reset the show-more expander every time the filter changes so
      // returning to "All" lands in the capped initial view (per spec).
      resetExpanded($section);

      if ($li.hasClass('active') && tag !== 'all') {
        $section.find('.add_on_tags li').removeClass('active');
        $section.find('.add_on_tags li[data-tag="all"]').addClass('active');
        applyFilter($section, 'all');
      } else {
        $section.find('.add_on_tags li').removeClass('active');
        $li.addClass('active');
        applyFilter($section, tag);
      }
    });

    // Inject per-pill counts so we can grey out empty buckets.
    $(SECTION).each(function () {
      var $section = $(this);
      var $tiles   = $section.find(ADDON_TILE);
      if (!$tiles.length) return;

      $section.find('.add_on_tags li').each(function () {
        var $li   = $(this);
        var tag   = ($li.data('tag') || '').toString();
        var count = countTiles($tiles, tag);
        var label = $li.text().replace(/\s*\(\d+\)\s*$/, '');
        $li.text(label + (tag !== 'all' && count > 0 ? ' (' + count + ')' : ''));
        if (count === 0 && tag !== 'all') $li.addClass('is-empty');
      });
    });

    function countTiles($tiles, tag) {
      if (tag === 'all') return $tiles.length;
      var needle = ('tag:' + tag).toLowerCase();
      return $tiles.filter(function () {
        return ($(this).attr('data-tag') || '').toLowerCase().indexOf(needle) !== -1;
      }).length;
    }

    // ---- 4. Addon-mode show-all expander -----------------------------------
    // Caps the addon grid at ADDON_MAX_ROWS rows on first paint regardless of
    // which filter pill is active. N and the visible/hidden split are
    // computed from the FILTERED set, so e.g. "Little Ones (13)" defaults to
    // one row + "Show all (13) v" expander, same as "All".
    // Jars have no cap (mode='jar' sections skip this entirely).

    function currentAddonCap() {
      var cols = (window.innerWidth <= MOBILE_BREAKPOINT)
        ? ADDON_COLS_MOBILE : ADDON_COLS_DESKTOP;
      return cols * ADDON_MAX_ROWS;
    }

    function applyAddonRowCap($section) {
      if ($section.attr('data-mode') !== 'addon') return;
      var $btn = $section.find(SHOW_MORE_BTN);
      if (!$btn.length) return;

      $section.find(ADDON_TILE).removeClass('is-row-capped');

      var $visible = $section.find(ADDON_TILE).not('.is-filtered-out');
      var cap      = currentAddonCap();
      var expanded = $btn.attr('data-expanded') === 'true';

      if ($visible.length <= cap) {
        $btn.attr('hidden', '');
        return;
      }

      if (!expanded) {
        $visible.each(function (i) {
          if (i >= cap) $(this).addClass('is-row-capped');
        });
        $btn.removeAttr('hidden').text('Show all (' + $visible.length + ') ▾');
      } else {
        $btn.removeAttr('hidden').text('Show less ▴');
      }
    }

    $(document).on('click', SECTION + ' ' + SHOW_MORE_BTN, function () {
      var $btn     = $(this);
      var $section = $btn.closest(SECTION);
      var expanded = $btn.attr('data-expanded') === 'true';
      $btn.attr('data-expanded', expanded ? 'false' : 'true');
      applyAddonRowCap($section);
    });

    // Re-apply cap when viewport crosses the mobile breakpoint (cols change).
    var lastIsMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    $(window).on('resize.addonRowCap', function () {
      var nowMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      if (nowMobile === lastIsMobile) return;
      lastIsMobile = nowMobile;
      $(SECTION).each(function () { applyAddonRowCap($(this)); });
    });

    // Initial cap pass.
    $(SECTION).each(function () { applyAddonRowCap($(this)); });

    // ---- 5. See-more modal (Modaal) ----------------------------------------
    // Bind on the class (not the non-unique #view-details-addon id).
    if (typeof $.fn.modaal === 'function') {
      $(document).on('mouseover.addonSeeMore', SEE_MORE_BTN, function () {
        // Lazy-init: bind modaal to each button only on first hover so a section
        // with many tiles doesn't pay all the init cost up front.
        var btn = this;
        if (btn.__modaalBound) return;
        btn.__modaalBound = true;
        $(btn).modaal({
          type: 'inline',
          content_source: '.addon-modal-content, .addon_pop_custom',
          before_open: async function (e) {
            var pro_url = $(e.currentTarget).attr('data-src');
            var data;
            try { data = await getProductDetails(pro_url); } catch (err) { return; }
            var imagesHTML = '';
            if (data && data.images && data.images.length > 0) {
              data.images.forEach(function (image) {
                imagesHTML += '<li class="splide__slide"><img src="' + image + '"></li>';
              });
            }
            if (typeof addOnModalButton !== 'undefined' && addOnModalButton) {
              addOnModalButton.dataset.vid = $(e.currentTarget).data('vid');
            }
            $('.product-modal-details .product-modal-title').text(data.title || '');
            $('.product-modal-details .product-modal-description').html(data.description || '');
            $('#addon-modal-photos').html(imagesHTML);
            try {
              new window.Splide('#addon_carousel', {
                type: 'slide', pagination: false, arrows: false
              }).mount();
            } catch (err) { /* may already be mounted */ }
          },
          after_close: function () {
            try {
              new window.Splide('#addon_carousel', {
                type: 'slide', pagination: false, arrows: false
              }).destroy();
            } catch (err) { /* */ }
          }
        });
      });
    }

    async function getProductDetails(URLPath) {
      var res = await fetch(window.location.origin + URLPath);
      return await res.json();
    }

    // ---- 5b. Template-shared personalisation sidecars (candle/prosecco/polaroid)
    // Both PDPs render these containers as siblings of the addon section.
    // Reveal/hide based on whether any active addon tile carries the trigger tag.
    function refreshPersonalisationSidecars() {
      var $activeAddons = $(ADDON_TILE + '.active');
      var hasCandle = false, hasProsecco = false, hasPolaroid = false;
      // Personalisation tag matchers (case-insensitive). Each sidecar accepts
      // multiple spelling variants because the legacy data baked in typos
      // (e.g. "persoanlisedbottle") that newly-tagged products won't carry.
      // Patterns are word-boundary-ish - require the prefix `product:personali`
      // so plain `product:personalised` (used on jars) doesn't accidentally
      // trigger an addon sidecar.
      var RE_CANDLE   = /product:personali[sz]edcandle/;
      var RE_PROSECCO = /product:(?:persoanli[sz]edbottle|personali[sz]edbottle|personali[sz]edprosecco)/;
      var RE_POLAROID = /product:(?:imageupload|personali[sz]edpolaroid)/;
      $activeAddons.each(function () {
        var t = ($(this).attr('data-tag') || '').toLowerCase();
        if (RE_CANDLE.test(t))   hasCandle   = true;
        if (RE_PROSECCO.test(t)) hasProsecco = true;
        if (RE_POLAROID.test(t)) hasPolaroid = true;
      });
      toggleSidecar($('.personalized-input-container.candle'),   hasCandle);
      toggleSidecar($('.personalized-input-container.prosecco'), hasProsecco);
      toggleSidecar($('.personalized-file-container'),           hasPolaroid);
    }
    function toggleSidecar($el, show) {
      if (!$el.length) return;
      if (show) $el.slideDown(); else { $el.slideUp(); $el.find('input[type="text"]').val(''); }
    }

    // ---- 6. Shared updateTotalPrice (single source of truth) ---------------
    // Reads prices from the DOM (already-fixed approach). Drives both the
    // sticky-bar total and the inline total span.
    window.updateTotalPrice = function () {
      var $selectedSwatch = $('.swatch_options input:checked+.swatch-element .prod-swatch-col-2');
      var basePrice = $selectedSwatch.length
        ? parseInt($selectedSwatch.data('price'), 10) || 0
        : (window.__lvlyBaseVariantPrice || 0);

      var totalPrice = basePrice;
      var addonsQty = 0;

      $(JAR_TILE + '.active').each(function () {
        var p = parseInt($(this).data('price'), 10);
        if (!isNaN(p)) totalPrice += p;
      });

      $(ADDON_TILE + '.active').each(function () {
        var p = parseInt($(this).data('price'), 10);
        if (isNaN(p)) return;
        var qty = parseInt($(this).find('.addon-qty-container input').val(), 10) || 1;
        totalPrice += p * qty;
        addonsQty += qty;
      });

      if (typeof window.Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && typeof currencyFormat !== 'undefined') {
        var finalPrice = Shopify.formatMoney(totalPrice, currencyFormat);
        $('.total-price-addon').text(finalPrice.replace('.00', ''));
      }
      $('.addon-prod-qty').text(addonsQty);
      refreshPersonalisationSidecars();
    };

    // Update on variant swatch change.
    $(document).on('change', ".swatch_options input[type='radio']", function () {
      window.updateTotalPrice();
    });

    // Initial paint.
    window.updateTotalPrice();
  });
})();
